import React from "react";
import { Home, Settings, Award, Users, Wallet } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { persistor } from "../../redux/app/store";
import { useAppDispatch } from "../../redux/app/hooks";
import { logout } from "../../redux/features/authSlice";
import { closeSidebar } from "../../redux/features/modalSlice";

const Sidebar = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const navItems = [
    { label: "Dashboard", icon: Home, to: "/dashboard" },
    { label: "Earnings", icon: Wallet, to: "/earnings" },
    { label: "Referrals", icon: Users, to: "/referrals" },
    // { label: "Rank Progression", icon: Award, to: "/rank-progression" },
    { label: "Settings", icon: Settings, to: "/settings" },
  ];

  return (
    <div className="flex flex-col h-screen bg-white border-r-2 border-gray-300 text-white w-full gap-12 py-4 overflow-y-auto">
      {/* Logo */}
      <div className="flex items-start justify-start h-16 p-4">
        <img
          src="/assets/images/svg/logo-dark.svg"
          alt="Logo"
          className="h-8"
        />
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-4">
        {navItems.map((item) => (
          <NavLink
            key={item.label}
            to={item.to}
            onClick={() => dispatch(closeSidebar())}
            className={({ isActive }) =>
              `flex items-center space-x-3 p-2 rounded hover:text-primary hover:decoration-white ${
                isActive
                  ? "border-l-4 border-white !text-primary decoration-white"
                  : "text-[#6F6F6F]"
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-4">
        <button
          className="flex items-center space-x-3 p-2 rounded  text-[#6F6F6F] hover:text-primary w-full"
          onClick={() => {
            dispatch(logout());
            navigate("/");
            persistor.purge();
          }}
        >
          <Home className="w-5 h-5" /> {/* You can replace icon */}
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
